module.exports = __webpack_public_path__ + "img/1579041076.1e5b94e6.jpg";